import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/joy/Grid';
import { Box, Typography, Stack } from '@mui/material';
import { Container, TopHeadingGrid } from '../style';
import { ColorsV2 } from 'app/constants/color';
import GapSlider from 'app/pages/gapanalysis/GapSlider';
import apiService from 'app/services/apiService';

const GapAnalysisTOS = () => {
  const [isQsLoading, setIsQsLoading] = useState(true);
  const [isAsLoading, setIsAsLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);

  const language = JSON.parse(localStorage.getItem('lang'));

  let res = null;
  const fetchTOSQuestions = async () => {
    try {
      res = await apiService.fetchTOSQuestions(language);
    } catch (error) {
      console.error(error);
    } finally {
      setIsQsLoading(false);
      setQuestions(res.data.questions);
    }
  };

  const fetchTOSAnswers = async () => {
    setIsAsLoading(true);
    let res = null;
    try {
      res = await apiService.fetchTOSAnswers(language);
    } catch (error) {
      console.error(error);
    } finally {
      setAnswers(res.data?.answers);
      setIsAsLoading(false);
    }
  };

  useEffect(() => {
    setIsQsLoading(true);
    setIsAsLoading(true);
    fetchTOSQuestions();
    fetchTOSAnswers();
    apiService.setIsUserTOS(true);
  }, []);

  const { t } = useTranslation('translation', { keyPrefix: 'gap_analysis' });

  return (
    <TopHeadingGrid>
      <Container sx={{ color: ColorsV2.white }}>
        <Typography
          variant='subtitle1'
          sx={{
            color: ColorsV2.textInfo,
          }}
        >
          {t('authtos_invited_description')}
        </Typography>
        <Box
          sx={{
            flexGrow: 1,
            padding: '20px',
            backgroundColor: ColorsV2.secondary,
            borderRadius: '4px',
            overflow: 'auto',
            bgcolor: ColorsV2.secondary,
            marginTop: '8px',
            marginBottom: '8px',
            borderColor: ColorsV2.white,
            borderStyle: 'solid',
            borderWidth: '2px',
          }}
        >
          <Typography variant='h3'>{t('nic_gap_tool')}</Typography>
          <Grid container spacing={2} sx={{ flexgrow: 1 }}>
            {isQsLoading ? (
              <Typography>{t('loading')}</Typography>
            ) : (
              <>
                {questions?.map(question => {
                  return (
                    <Grid
                      item
                      key={question.id}
                      component='section'
                      sx={{
                        width: '100%',
                        borderBottom: 'solid 1px',
                        borderColor: ColorsV2.acent,
                        paddingBottom: '25px',
                      }}
                    >
                      <Typography
                        variant='h6'
                        sx={{
                          paddingBottom: '10px',
                          paddingTop: '10px',
                          width: '100%',
                        }}
                      >
                        {question.description}
                      </Typography>
                      {/* Question index is removed on the TOS-user version to avoid confusion (The numbers will not match up)
                                <Typography variant='subtitle2' color={ColorsV2.acent}>
                                    {index + 1}.
                                </Typography> */}
                      <Typography
                        variant='body2'
                        sx={{
                          paddingBottom: '15px',
                          color: ColorsV2.textInfo,
                        }}
                      >
                        {question.text}
                      </Typography>
                      <Stack
                        direction='row'
                        alignItems='center'
                        spacing={4}
                        sx={{
                          bgcolor: ColorsV2.primary,
                          marginBottom: '10px',
                          marginTop: '2px',
                          borderRadius: '10px',
                          paddingTop: '5px',
                          paddingRight: '10px',
                          paddingLeft: '10px',
                          boxShadow:
                            'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
                        }}
                      >
                        {isAsLoading && !answers[question.id] ? (
                          <Typography>{t('loading')}</Typography>
                        ) : (
                          <GapSlider
                            answer={answers[question.id]}
                            questionId={question.id}
                          ></GapSlider>
                        )}
                      </Stack>
                    </Grid>
                  );
                })}
              </>
            )}
          </Grid>
        </Box>
      </Container>
    </TopHeadingGrid>
  );
};

export default GapAnalysisTOS;
